import React from 'react'
import Dropdown, { DropdownTrigger, DropdownContent } from 'react-simple-dropdown'
import { ChevronDown } from 'react-feather'

const LanguageDropdown = ({onChange}) => {
  const [flag, setFlag] = React.useState('/images/flags/khub_english.svg')

  const handleChange = (lang) => {
    if(typeof onChange === 'function'){
      onChange(lang)
    }

    if(lang === 'en'){
      setFlag('/images/flags/khub_english.svg')
    } else if(lang === 'id'){
      setFlag('/images/flags/khub_indonesia.svg')
    }
  }

  return (
    <React.Fragment>
      <Dropdown>
        <DropdownTrigger>
          <div className="flex items-center cursor-pointer ml-8">
            <div
              style={{backgroundImage: `url('${flag}')`, height: '15px', width: '20px', backgroundSize: '100%', backgroundColor: '#f8f8f8'}}
              className="bg-no-repeat bg-center mr-2"
            />
            <ChevronDown style={{color: '#fff', width: '18px'}}/>
          </div>
        </DropdownTrigger>
        <DropdownContent className="language-dropdown-content">
          <div>
            <ul className="p-5 font-primary normal-case font-normal border-b" style={{borderColor: '#eee'}}>
              <li className="cursor-pointer mb-2" onClick={() => handleChange('en')}>
                English
              </li>
              <li className="cursor-pointer " onClick={() => handleChange('id')}>
                Bahasa
              </li>
            </ul>
          </div>
        </DropdownContent>
      </Dropdown>
    </React.Fragment>
  )
}

export { LanguageDropdown }
